import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

/**
 * Client-side gate only - purely a UX convenience to avoid flashing admin
 * UI at unauthenticated users. Every actual write is re-checked server-side
 * by the Lambda's withAdminAuth middleware regardless of what this renders.
 */
export default function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { loading, isAuthenticated } = useAuth();

  if (loading) return <div style={{ padding: 24 }}>Loading...</div>;
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  return <>{children}</>;
}
